import { type FileTrackingItem } from '@air/feature-file-status/ui';
import { type Upload, type UploadProgressInfo, UploadStatus } from '@air/redux-uploader';

export const convertUploadToFileTrackingPaneItem = (
  upload: Upload,
  progressInfo?: UploadProgressInfo,
): FileTrackingItem => {
  return {
    currentBytesUploaded: progressInfo?.progress || 0,
    error: upload.status === UploadStatus.failed ? upload.errorMessage || 'Failed' : '',
    ext: upload.apiUploadData.ext,
    id: upload.id,
    includeErrorInSummary: true,
    sizeInBytes: upload.apiUploadData.size || 0,
    status: upload.status,
    thumbnailSource: upload.imageBase64,
    title: upload.apiUploadData.importedName,
  };
};
